module.exports = __webpack_public_path__ + "img/arrow-up-left-square-fill.fdc004d3.svg";